module.exports = __webpack_public_path__ + "fondo-body.svg?aa956ff6e41a3cc31719aadc5f7a8683";


//////////////////
// WEBPACK FOOTER
// ./src/img/fondo-body.svg
// module id = 237
// module chunks = 0